import { createContext, useContext } from "react";

import type { EmbeddablesUser } from "../models";

export const EmbeddablesUserContext = createContext<EmbeddablesUser | null>(
  null,
);

export const useEmbeddablesUser = () => {
  const context = useContext(EmbeddablesUserContext);

  if (!context) {
    throw new Error(
      "useEmbeddablesUser must be used within a <EmbeddablesUserContext.Provider />",
    );
  }

  return context;
};
